import {css} from '../theme/css'

export const classes = {
  disabled: css`
    opacity: 0.5 !important;
  `,
}
